exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".likert-table.single td:nth-child(1) {\n  vertical-align: middle; }\n  .likert-table.single td:nth-child(1):hover {\n    background-color: inherit; }\n", ""]);

// exports
